<template>
    <div id="app">
        <Loading v-if="$store.state.isLoading"></Loading>
        <router-view></router-view>
    </div>
</template>

<script>
import Loading from './components/Loading.vue';
export default {
    name: 'app',
    components: { Loading },
    provide() {
        return {
            main: this
        };
    },
    data() {
        return {
            theme: ''
        }
    },
    mounted(){
        console.log("【版本号】：1.0.14")
    }
}
</script>

<style></style>
